<template>
    <v-textarea
        v-bind="$attrs"
        dense
        v-on="$listeners"
        outlined
        :label="labelComputed"
    />
</template>

<script>
import RequiredField from "../../Mixins/RequiredField";

export default {
    name: "TextareaField",
    mixins: [RequiredField],
};
</script>

<style scoped></style>
